import { ListItemIcon as NovaBaseListItemIcon } from '@fme-nova/components'
import { default as MuiBaseListItemIcon, ListItemIconProps } from '@mui/material/ListItemIcon'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiListItemIcon: MsdkStyledComponent<ListItemIconProps> = styled(MuiBaseListItemIcon)`
  color: ${COLORS.primary.main};
`

export const ListItemIcon = createComponentWrapperWithRef<ListItemIconProps>(
  {
    mui: MuiListItemIcon,
    nova: NovaBaseListItemIcon,
  },
  'ListItemIcon',
)
